import { trackFeedbackEvents } from '@modules/feedback/utils';
import { IconButton } from '@mui/material';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';

export const FeedbackDetailsHeaderCloseIcon = ({
  onDrawerClose,
  feedbackID,
}: {
  onDrawerClose?: () => void;
  feedbackID: string;
}) => {
  if (!onDrawerClose) {
    return null;
  }

  const onCloseButtonClick = () => {
    onDrawerClose();

    trackFeedbackEvents({
      eventName: 'Feedback Card Collapsed',
      feedbackID: feedbackID,
    });
  };

  return (
    <IconButton
      onClick={onCloseButtonClick}
      aria-label="Close drawer"
      sx={{
        borderRadius: '50%',
        border: '1px solid',
        borderColor: 'divider',
      }}
    >
      <CloseRoundedIcon />
    </IconButton>
  );
};
